// =====================================================
// 🏠 DASHBOARD HOME - ROUTER POR ROL
// =====================================================

import { useAuthStore } from '../../stores/authStore'
import OperationalDashboard from './OperationalDashboard'
import TechnicianDashboard from './TechnicianDashboard'
import UserDashboard from './UserDashboard'

export default function DashboardHome() {
  const { user } = useAuthStore()
  
  // 🔍 Normalizar rol para evitar problemas de case/trim
  const normalizeRole = (role: string | undefined): string => {
    if (!role) return 'user'
    return role.toString().toLowerCase().trim()
  }
  
  const effectiveRole = normalizeRole(user?.role)
  
  console.log('🏠 [DashboardHome] Usuario detectado:', {
    userId: user?.id,
    userName: user?.name,
    rawRole: user?.role,
    normalizedRole: effectiveRole
  })
  
  // ✅ ADMIN VE EL DASHBOARD OPERACIONAL COMPLETO
  if (effectiveRole === 'admin' || effectiveRole === 'administrator' || effectiveRole === 'administrador') {
    console.log('🏠 [DashboardHome] ✅ Mostrando OperationalDashboard para admin')
    return <OperationalDashboard />
  }
  
  // ✅ TÉCNICOS VEN DASHBOARD CON ESTADÍSTICAS GLOBALES + MÉTRICAS PERSONALES
  if (effectiveRole === 'technician' || effectiveRole === 'técnico' || effectiveRole === 'tecnico') {
    console.log('🏠 [DashboardHome] ✅ Mostrando TechnicianDashboard para técnico')
    return <TechnicianDashboard />
  }
  
  // ✅ USUARIOS VEN DASHBOARD SIMPLE PERSONAL
  console.log('🏠 [DashboardHome] ✅ Mostrando UserDashboard para:', effectiveRole)
  return <UserDashboard />
}